const dashboard = {
  dashboard: {
    title: 'Pulpit nawigacyjny',
    switchToClassic: 'Przełącz na widok klasyczny',
    comingSoon: 'Już wkrótce',
    companyScoreCard: 'Karta wyników firmy',
    enphaseSince: 'Instalowanie systemów Enphase od',
    sitesCommissioned: 'Oddane lokalizacje',
    microinverters: 'Zainstalowane mikroinwertery',
    batteriesInstalled: 'Zainstalowane akumulatory',
    nps: 'Poziom zadowolenia klientów (NPS)',
    ensembleCertified: 'Firma Autoryzowanej Instalacji Storage',
    einLearn: 'Dowiedz się więcej o EIN',
    yes: 'Tak',
    no: 'Nie',
    lastMonth: {
      one: 'w ciągu ostatniego miesiąca',
      other: 'w ciągu ostatnich %{count} miesięcy'
    },
    congratulations: 'Gratulujemy!',
    acceptInvitation: 'Zaakceptuj zaproszenie',
    einInvitation: 'Otrzymano zaproszenie do dołączenia do Sieci instalatorów Enphase.',
    leadsInvitation:
      'Otrzymano zaproszenie do dołączenia do programu Enphase dot. potencjalnych klientów (Enphase Leads Program).',
    announcements: 'Ogłoszenia',
    systems: 'Systemy',
    all: 'Wszystkie',
    alerts: 'Alerty',
    activations: 'Aktywacje',
    leads: 'Potencjalni klienci',
    search: 'Szukaj',
    noResult: 'Brak wyników',
    viewActivations: 'Wyświetl wszystkie aktywacje',
    viewLeads: 'Wyświetl wszystkich potencjalnych klientów',
    viewSystems: 'Wyświetl wszystkie systemy',
    addNewSystems: 'Dodaj nowy system',
    total: 'Łącznie',
    activatedSites: 'Aktywowane lokalizacje',
    nameId: 'Nazwa/identyfikator',
    status: 'Status',
    city: 'Miejscowość',
    state: 'Województwo/powiat',
    leadSource: 'Źródło potencjalnych klientów',
    createNewLead: 'Utwórz nowego potencjalnego klienta',
    notAvailable: 'Niedostępny',
    quickAccess: 'Szybki dostęp',
    contactUs: 'Skontaktuj się z nami',
    ensemble: 'Ensemble',
    serviceShortcuts: 'Skróty do usług',
    newsletter: 'Biuletyn instalatora',
    service: 'Menedżer usług',
    enphaseleads: 'Program Enphase Leads',
    enphaseCommunity: 'Społeczność Enphase',
    enphaseStore: 'Sklep Enphase',
    systemConfigurator: 'Konfigurator systemu',
    criticalUpdates: 'Aktualizacje krytyczne',
    documentation: 'Dokumentacja',
    brandLibrary: 'Biblioteka marek',
    training: 'Szkolenie',
    newsBoard: 'Tablica aktualności',
    noContentAvailable: 'Brak dostępnych treści',
    viewEinDashboard: 'Wyświetl pulpit EIN',
    enterComments: 'Wprowadź swoje komentarze',
    maxAllowedComment: 'Dozwolone jest maksymalnie %{maxCount} znaków',
    switchingBackNote:
      'Wracasz do klasycznej wersji Enlighten Managera? Pomóż nam ulepszyć nową wersję, podając powód zmiany',
    switchBackTitle: 'Przełącz na widok klasyczny tymczasowo',
    new: 'Nowe',
    view: 'Widok',
    gridProfileToken: 'Token zmiany profilu sieci',
    ProfileTokenText: 'Token zmiany profilu',
    validText: 'Ten token jest ważny dla bramy Envoy o numerze seryjnym %{serialNumber} przez jeden dzień.',
    envoySerialNumber: 'Numer seryjny bramy Envoy',
    authorizationNumber: 'Numer autoryzacji',
    getToken: 'Pobierz token',
    viewAll: 'Wyświetl wszystko',
    viewFullList: 'Wyświetl pełną listę',
    serviceRequests: 'Prośby dotyczące usług',
    inProgressRequests: 'W toku',
    totalCases: 'Wszystkie przypadki',
    resolvedRequests: 'Rozwiązane',
    viewDetails: 'Wyświetl szczegóły'
  }
};

export default dashboard;
